import { Link } from 'react-router-dom';
import { Package } from 'lucide-react';
import WidgetShell from '../WidgetShell';
import { useTopProducts } from '@/hooks/dashboard/useEcomDashboard';
import { formatCurrency } from '@/lib/utils';

export default function TopProductsWidget() {
  const { data: products, isLoading, error } = useTopProducts();

  return (
    <WidgetShell
      title="Top Products"
      icon={<Package />}
      to="/admin/products"
      isLoading={isLoading}
      error={error}
      isEmpty={!!products && products.length === 0}
      emptyMessage="No product sales yet"
      emptyIcon={<Package />}
      skeletonClassName="h-40"
    >
      {products && products.length > 0 && (
        <ul className="divide-y divide-line">
          {products.slice(0, 5).map((product, index) => (
            <li key={product.id}>
              <Link
                to={`/admin/products/${product.id}`}
                className="flex items-center gap-3 py-2 hover:bg-stone-50"
              >
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-stone-100 text-xs font-semibold text-stone-600">
                  {index + 1}
                </span>
                {product.primary_image_url ? (
                  <img
                    src={product.primary_image_url}
                    alt=""
                    className="h-9 w-9 shrink-0 rounded-md object-cover"
                  />
                ) : (
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-stone-200">
                    <Package className="h-4 w-4 text-stone-400" />
                  </div>
                )}
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-ink">{product.name}</p>
                  <p className="text-xs text-stone-500">{product.units_sold} sold</p>
                </div>
                <span className="text-sm font-semibold text-ink">
                  {formatCurrency(product.revenue)}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </WidgetShell>
  );
}
